import styled from 'styled-components'
import twoAtoms from '../../images/twoatoms.svg'



export const DisplayContainer = styled.div`
        padding: 14vh 10vw 15vh;
        height: 32vh;
        background-color: #363636;
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
        
    `

export const ContactImage = styled.div`
    background-image:url(${twoAtoms});
    background-size: cover;
    height: 18vw;
    @media screen and (max-width: 1200px) {
        display: none;
    }
`

export const KitButton = styled.a`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 19vw;
    height: 10vh;
    border: 2px solid #FF4C00;
    color: #fff;
    background-color: inherit;
    margin: 6vh auto 0;
    text-align: center;
    text-decoration: none;
    cursor: pointer;
    opacity: 0.9;
    font-size: 20px;
    font-family: Michroma,serif;
    @media screen and (max-width: 768px) {
        margin: 0 auto;
        width: 30vw;
        height: 6vh;
        font-size: 15px;
        line-height: 3vh;
        padding: 0.27vh 0;
    }
    @media screen and (max-width: 480px) {
        font-size: 12px;
    }
    &:hover, &:active {
        text-decoration: none;
        color: white;
    }
    &:hover{
        background-color: #444;
        opacity: 1;
    }
    &:active{
        background-color: #363636;
        opacity: 1.2;
    }
`

export const H1 = styled.h1`
    font-size: 30px;
    font-family: Michroma;
    @media screen and (max-width: 480px) {
        font-size: 18px;
    }
`

export const TextSeciton = styled.div`
    width: 40vw; 
    margin-top: 2.4vw;
    
`
